// extracted by mini-css-extract-plugin
export var searchHeader = "_28-0";
export var searchHeaderDark = "_28-1";